import { useFormikContext } from 'formik';
import { Label } from '@antimatterhq/ui/components/label';
import { FormError, FormInput } from '@/components/form/form';
import { TransformSchemaValues } from '@/zod/schemas/transforms/TransformSchema';

export const TransformOutputTableForm = () => {
  const { values, handleChange, handleBlur } =
    useFormikContext<TransformSchemaValues>();

  return (
    <>
      <Label htmlFor="outputTable" id="outputTable-label" required>
        Destination table
      </Label>
      <FormInput
        name="outputTable"
        placeholder="Enter the destination table"
        value={values.outputTable}
        onChange={handleChange}
        onBlur={handleBlur}
        aria-labelledby="outputTable-label"
      />
      <FormError name="outputTable" />
    </>
  );
};
